import styled from "@emotion/styled";
import { Grid, Modal, Typography, Divider, Button, Stack } from "@mui/material";
import { green, grey, pink, yellow } from "@mui/material/colors";
import { Box } from "@mui/system";
import React, { useCallback, useEffect } from "react";
import SALES_RECORD_TYPE from "../../utils/variable";
import { detailIsEmpty } from "./util/InitialSalesRecord";

const ListSalesDetailHeader = styled(Grid)({
  margin: 0,
  padding: 0,
  display: "flex",
  justifyContent: "center",
});

const UpsertConfirmModal = ({
  setOpen,
  salesRecord,
  salesDetails,
  salesResultses,
  confirmAction,
  ranks,
  productClasses,
  packings,
}) => {
  const salesRecordType = salesRecord.Value.salesRecordTypeCd;
  const showSalesDetails = salesDetails.Value.filter(
    (salesDetail) => !detailIsEmpty(salesDetail)
  );

  const sumQuantityBySalesDetailNo = useCallback(
    (salesDetailNo) => {
      const totalQuantity = salesResultses.Value.reduce((sum, cur) => {
        if (cur.salesDetailNo == salesDetailNo) {
          return sum + parseInt(cur.quantity);
        }
        return sum;
      }, 0);
      return totalQuantity;
    },
    [salesResultses.Value]
  );

  const mapDetailQuantity = new Map();

  showSalesDetails.forEach((salesDetail) => {
    const sumResultQuantity = sumQuantityBySalesDetailNo(
      salesDetail.salesDetailNo
    );
    mapDetailQuantity.set(salesDetail.salesDetailNo, {
      quantity: salesDetail.quantity,
      sumResultQuantity: sumResultQuantity,
      isValid:
        salesRecordType === SALES_RECORD_TYPE.LOCAL
          ? sumResultQuantity == salesDetail.quantity
          : sumResultQuantity <= salesDetail.quantity,
    });
  });

  const handleKeyPress = useCallback(
    (event) => {
      if (event.key === "Insert") {
        const dataIsInvalid = Array.from(mapDetailQuantity.values()).some(
          ({ isValid }) => !isValid
        );
        if (dataIsInvalid) return;
        confirmAction();
      }
    },
    [mapDetailQuantity, salesRecordType]
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      window.addEventListener("keydown", handleKeyPress);
    }, 100);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <Modal open={true} onBackdropClick={() => setOpen(false)}>
      <Box
        sx={{ height: "100vh" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          //   justifyContent="space-around"
          alignItems="center"
          sx={{
            width: "1200px",
            minHeight: "200px",
            backgroundColor: "white",
            borderRadius: 3,
            padding: 3,
            // opacity: 0.75,
          }}
        >
          <Stack sx={{ width: "100%" }}>
            <Typography variant="h5">以下の内容を登録しますか？</Typography>
            <Divider sx={{ my: 2 }}></Divider>
            <ListSalesDetailHeader
              container
              sx={{ backgroundColor: green[100], borderRadius: 1 }}
            >
              <Grid item xs={1}>
                <Typography variant="h5" textAlign={"left"}>
                  No.
                </Typography>
              </Grid>
              <Grid item xs={1.5}>
                <Typography variant="h5" textAlign={"center"}>
                  等級
                </Typography>
              </Grid>
              <Grid item xs={1.5}>
                <Typography variant="h5" textAlign={"center"}>
                  階級
                </Typography>
              </Grid>
              <Grid item xs={1.5}>
                <Typography variant="h5" textAlign={"center"}>
                  荷姿
                </Typography>
              </Grid>
              <Grid item xs={1.5}>
                <Typography variant="h5" textAlign={"center"}>
                  量目ｇ
                </Typography>
              </Grid>
              <Grid item xs={0.25} />
              <Grid item xs={1.5}>
                <Typography variant="h5" textAlign={"center"}>
                  数量
                </Typography>
              </Grid>
              {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
                <Grid item xs={1.5}>
                  <Typography variant="h5" textAlign={"center"}>
                    仕入値
                  </Typography>
                </Grid>
              )}
              {salesRecordType === SALES_RECORD_TYPE.LOCAL && (
                <Grid item xs={1.5}>
                  <Typography variant="h5" textAlign={"center"}>
                    内容明細
                  </Typography>
                </Grid>
              )}
              <Grid item xs={0.25} />
              <Grid item xs={1.5}>
                <Typography variant="h5" textAlign={"center"}>
                  販売実績合計
                </Typography>
              </Grid>
            </ListSalesDetailHeader>

            {/* Body */}
            <Box sx={{ width: "100%" }}>
              {showSalesDetails.map((salesDetail) => {
                const { sumResultQuantity, isValid } = mapDetailQuantity.get(
                  salesDetail.salesDetailNo
                );
                return (
                  <Grid
                    container
                    sx={{
                      backgroundColor: !isValid ? pink[50] : "white",
                      borderBottom: `1px solid ${grey[300]}`,
                      borderRadius: 1,
                      py: 0,
                      height: 38,
                    }}
                  >
                    <Grid item xs={1} sx={{ pl: 1 }}>
                      <Typography variant="h5" textAlign={"left"}>
                        {salesDetail.salesDetailNo}
                      </Typography>
                    </Grid>
                    <Grid item xs={1.5}>
                      <Typography variant="h5" textAlign={"left"}>
                        {/* 等級 */}
                        {/* {salesDetail.rankId} */}
                        {
                          ranks.find(
                            (rank) => rank.rankId == salesDetail.rankId
                          )?.rankName
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs={1.5}>
                      <Typography variant="h5" textAlign={"left"}>
                        {/* 階級 */}
                        {/* {salesDetail.productClassId} */}
                        {
                          productClasses.find(
                            (productClass) =>
                              productClass.productClassId ==
                              salesDetail.productClassId
                          )?.productClassName
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs={1.5}>
                      <Typography variant="h5" textAlign={"left"}>
                        {/* 荷姿 */}
                        {/* {salesDetail.packingId} */}
                        {
                          packings.find(
                            (packing) =>
                              packing.packingId == salesDetail.packingId
                          )?.packingName
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs={1.5}>
                      <Typography variant="h5" textAlign={"right"}>
                        {/* 量目ｇ */}
                        {salesDetail.weight}
                      </Typography>
                    </Grid>
                    <Grid item xs={0.25} />
                    <Grid
                      item
                      xs={1.5}
                      sx={{ px: 1, backgroundColor: yellow[100] }}
                    >
                      <Typography
                        variant="h5"
                        textAlign={"right"}
                        sx={{ fontWeight: 550 }}
                      >
                        {/* 数量 */}
                        {salesDetail.quantity}
                      </Typography>
                    </Grid>
                    {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
                      <Grid item xs={1.5}>
                        <Typography variant="h5" textAlign={"right"}>
                          {/* 仕入値 */}
                          {salesDetail.purchacePrice}
                        </Typography>
                      </Grid>
                    )}
                    {salesRecordType === SALES_RECORD_TYPE.LOCAL && (
                      <Grid item xs={1.5}>
                        <Typography variant="h5" textAlign={"center"}>
                          {/* 内容明細 */}
                          {salesDetail.remarks}
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={0.25} />
                    <Grid
                      item
                      xs={1.5}
                      sx={{ px: 1, backgroundColor: yellow[100] }}
                    >
                      <Typography
                        variant="h5"
                        textAlign={"right"}
                        sx={{ fontWeight: 550 }}
                      >
                        {/* 販売実績合計 */}
                        {sumResultQuantity}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
            </Box>
            {/* Footer */}
            <Box
              display="flex"
              justifyContent="end"
              sx={{ width: "100%" }}
              mt={2}
            >
              <Button
                // size="large"
                disabled={Array.from(mapDetailQuantity.values()).some(
                  ({ isValid }) => !isValid
                )}
                sx={{ width: 150, height: 40, fontSize: 15, marginInline: 2 }}
                variant="contained"
                mx={2}
                onClick={confirmAction}
              >
                登録
              </Button>
              <Button
                sx={{ width: 150, height: 40, fontSize: 15 }}
                color="error"
                variant="contained"
                onClick={() => setOpen(false)}
              >
                キャンセル
              </Button>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpsertConfirmModal;
